import { Capacitor, registerPlugin } from '@capacitor/core';

// Lazy-loaded FCM plugin reference (iOS only)
let FCMTokenPlugin = null;
let pluginInitialized = false;

const getFCMPlugin = () => {
  if (pluginInitialized) return FCMTokenPlugin;
  pluginInitialized = true;

  if (Capacitor.getPlatform() === 'ios') {
    try {
      FCMTokenPlugin = registerPlugin('FCMToken');
    } catch (err) {
      // Plugin already registered or not available
      console.warn('FCMToken plugin registration:', err.message);
    }
  }
  return FCMTokenPlugin;
};

/**
 * Get the FCM token for the current device
 * Returns cached token from localStorage if available, otherwise fetches from native
 */
export const getDeviceFcmToken = async () => {
  const platform = Capacitor.getPlatform();
  console.log('[fcmToken] getDeviceFcmToken called, platform:', platform);

  // First check localStorage for cached token (works for all platforms)
  const cachedToken = localStorage.getItem('deviceFcmToken');
  console.log('[fcmToken] Cached token:', cachedToken ? 'exists' : 'not found');
  if (cachedToken) {
    return cachedToken;
  }

  if (platform === 'ios') {
    const plugin = getFCMPlugin();
    console.log('[fcmToken] iOS plugin:', plugin ? 'loaded' : 'not available');
    if (plugin) {
      // iOS: get from native plugin
      try {
        console.log('[fcmToken] Calling plugin.getToken()...');
        const result = await plugin.getToken();
        console.log('[fcmToken] Plugin result:', result);
        if (result?.token) {
          localStorage.setItem('deviceFcmToken', result.token);
          return result.token;
        }
      } catch (err) {
        console.warn('[fcmToken] iOS FCM token error:', err);
      }
    }
    return null;
  }

  // Android and Web tokens are set via saveDeviceFcmToken
  return null;
};

/**
 * Save the FCM token to localStorage
 */
export const saveDeviceFcmToken = (token) => {
  if (token) {
    localStorage.setItem('deviceFcmToken', token);
  }
};

/**
 * Clear the cached FCM token
 */
export const clearDeviceFcmToken = () => {
  localStorage.removeItem('deviceFcmToken');
};
